<template>
  <div>
    <button
      class="btn"
      :class="{ 'btn-success': !student.active, 'btn-danger': student.active }"
      @click="showConfirmModal = true"
    >
      {{ student.active ? 'Desativar' : 'Ativar' }}
    </button>
    <confirm-modal v-if="showConfirmModal" @close="showConfirmModal = false;" @confirm="emitUpdateAction" />
  </div>
</template>
<script>
import ConfirmModal from 'components/ConfirmModal';

export default {
  components: {
    ConfirmModal,
  },
  data() {
    return {
      showConfirmModal: false,
    };
  },
  props: {
    student: {
      type: Object,
      required: true,
    },
  },
  methods: {
    emitUpdateAction() {
      this.$emit(this.student.active ? 'deactivate' : 'activate', this.student);
      this.showConfirmModal = false;
    },
  },
};
</script>
